import { browserFeatures } from './browser-utils.js';

/**
 * Insert a node after an existing one
 * @param {Node} referenceNode
 * @param {Node} newNode
 */
export const insertAfter = (referenceNode, newNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

const _collectAllDescendants = (node) => {
  let collection = [node];
  for (let i = 0; i < node.childNodes.length; i++) {
    collection = collection.concat(_collectAllDescendants(node.childNodes[i], collection));
  }
  return collection;
};

/**
 * Collects and returns all descendants starting from a list of nodes for easy access through all elements in a tree.
 * @param {Node[]} nodes
 * @returns {Node[]}
 */
export const getAllDescendantsOf = nodes => _collectAllDescendants({ childNodes: nodes }).slice(1);

export const hideNode = node => node && (node.style.display = 'none');

export const showNode = (node, display = 'block') => node && (node.style.display = display);

/**
 * Returns the position of a DOM node relative to the document.
 * @param {Node} el
 * @returns {{top: number, left: number}}
 */
export function nodeOffset(el, ignoreScroll = false) {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + (ignoreScroll ? 0 : scrollTop), left: rect.left + (ignoreScroll ? 0 : scrollLeft) };
}

export class SwipeHandler {
  constructor(element, horizThreshold) {
    this.horizThreshold = horizThreshold || 30;
    this.element = element;
    this._touchStartHandler = this.handleTouchStart.bind(this);
    this._touchMoveHandler = this.handleTouchMove.bind(this);
    this.xDown = null;
    this.element.addEventListener('touchstart', this._touchStartHandler, browserFeatures.supportsPassive ? {passive: true} : false);
  }

  onLeft(callback) {
    this.onLeft = callback;
    return this;
  }

  onRight(callback) {
    this.onRight = callback;
    return this;
  }

  handleTouchStart(evt) {
    this.xDown = evt.touches[0].clientX;
  }

  handleTouchMove(evt) {
    if (!this.xDown) {
      return;
    }
    var xUp = evt.touches[0].clientX;
    let xDiff = this.xDown - xUp;

    if (Math.abs(xDiff) > this.horizThreshold) {
      if (xDiff > 0) {
        this.onLeft();
      } else {
        this.onRight();
      }
      // Reset values.
      this.xDown = null;
    }
  }

  run() {
    this.element.addEventListener('touchmove', this._touchMoveHandler, browserFeatures.supportsPassive ? {passive: true} : false);
  }

  dispose() {
    this.element.removeEventListener("touchstart", this._touchStartHandler);
    this.element.removeEventListener("touchmove", this._touchMoveHandler);
  }
}

